(function () {
  'use strict';

  function init(root) {
    if (root.dataset.carderiaBannersReady === 'true') return;
    const track = root.querySelector('[data-carderia-banners-track]');
    const slides = Array.from(root.querySelectorAll('.carderia-banner'));
    if (!track || slides.length < 2) return;
    root.dataset.carderiaBannersReady = 'true';

    const status = root.querySelector('[data-carderia-banner-status]');
    const previous = root.querySelector('[data-carderia-banner-prev]');
    const next = root.querySelector('[data-carderia-banner-next]');
    let current = 0;
    let timer;
    let paused = false;

    function show(index) {
      current = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      if (status) status.textContent = (current + 1) + ' / ' + slides.length;
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    }

    function start() {
      stop();
      if (root.dataset.autoplay !== 'true' || paused || document.hidden ||
          window.Shopify && window.Shopify.designMode ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () { show(current + 1); }, 6000);
    }

    previous.addEventListener('click', function () { show(current - 1); start(); });
    next.addEventListener('click', function () { show(current + 1); start(); });
    track.addEventListener('scroll', function () {
      if (!track.clientWidth) return;
      current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      if (status) status.textContent = (current + 1) + ' / ' + slides.length;
    }, { passive: true });
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () {
      window.setTimeout(function () { if (!root.contains(document.activeElement)) { paused = false; start(); } }, 0);
    });
    document.addEventListener('visibilitychange', start);
    document.addEventListener('shopify:block:select', function (event) {
      const index = slides.findIndex(function (slide) { return slide.contains(event.target) || slide === event.target; });
      if (index >= 0) show(index);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root)) stop();
    });
    start();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-carderia-banners]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
